import SalesSetting from './SalesSetting';

export default SalesSetting;
